var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertCircle = function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 21,
    fill: "none",
    viewBox: "0 0 19 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C15701",
    d: "M10.5 2.167c4.592 0 8.333 3.741 8.333 8.333s-3.741 8.333-8.333 8.333-8.333-3.741-8.333-8.333S5.908 2.167 10.5 2.167m0 1.666A6.676 6.676 0 0 0 3.833 10.5a6.676 6.676 0 0 0 6.667 6.667 6.676 6.676 0 0 0 6.667-6.667A6.676 6.676 0 0 0 10.5 3.833m0 8.75a1.042 1.042 0 1 1 0 2.084 1.042 1.042 0 0 1 0-2.084m.833-1.25H9.667v-5h1.666z"
  })));
};
export { SvgAlertCircle as Icon };
export default __webpack_public_path__ + "static/media/0e6161416227af59f08587dd2322e90c.svg";